(function ($, window) {
	"use strict";

	var TnT = function (pluginname) {
	    var $ref, $btn, enterClick = false;

		var _events = { SEARCH: pluginname + ".search" };

		this.events = function () { return _events; };

		this.checkData = function () {
			// Correct input before continuing
			this.TnT("correctRefInput");

			var refVal = $ref.val(),
				mess = "";

			if (refVal === "")
			{ mess = "Please enter a reference"; }
				// Display error is any of the entries is below 5 chars long
			else if (!/^[^,]{3,}([,][^,]{3,})*$/g.test(refVal))
			{ mess = "References should be at least 3 characters long"; }

			var valid = (mess === "");

			// If a message has been defined, the field is not valid
			// If the field did not validata: alert the message
			if (!valid)
			{
			    window.alert(mess);
			    $ref.focus();
				// Toggle error class if the field did not validate
				$ref.addClass("invalid");
			} else {
				$ref.removeClass("invalid");
			}

			// Return validation result
			return valid;
		};

		this.search = function () {

			if (enterClick) {
				// IE apparently demands the name to contain the word 'window' to open it in a new window???
				// void added to avoid firefox returning af value, triggering selenium to open a new window...

				enterClick = false;
				void(window.open($btn.prop("href"), "TnTwindow"));

				this.trigger(_events.SEARCH);
			} else {
				return false;
			}
		};

		this.updateLink = function () {
			var url = $btn.prop("href").split("?")[0] +
				"?params=%257B%2522searchValue%2522%253A%2522" + $ref.val().toUpperCase() +
				"%2522%257D" +
				"&state=search"

			// Open the window before submitting the form, by triggering a click-event on the TnT button, as to trigger GA Link Click Event
			$btn.attr('href', url);
		};

		this.correctRefInput = function () {
			var val = $ref.val();
			// 1. Replace spaces with ","
			// 2. Replace multiple "," width a single ","
			// 3. Trim away trailing "," and spaces from the ends of the string
			val = val
					.replace(/\s+/g, ",")
					.replace(/[,]{2,}/g, ",")
					.replace(/^[,]+|[,]+$/g, "");		    

			$ref.val(val);

			this.TnT("updateLink");
		};

		this.init = function () {
		    var $tnt = this;

			$ref = this.find("#tntReference");
			$btn = this.find("[class*='btn']");

			// Do stuff on startup
			// Apply event on enter pressed on the input field
			$ref
			.on("keypress", function (e) {
			    if (e.which === 13) {
			        if (!!$tnt.TnT("checkData")) {
			            enterClick = true;
			            $tnt.TnT("search");
			            $btn.trigger("click");
			        }
			        e.preventDefault();
			    }
			})
			.on("keyup", function (e) {
				if (e.which === 13) {
					return false;
				}
			})
			.on("change", function () {
				$tnt.TnT("correctRefInput");
			});

			// Apply search function to the button
			$btn.on("click", function (e) {
			    if (!!$tnt.TnT("checkData")) {
			        
			    } else {
			        return false;
			    }
			});
		};

	};

	$.plugin("TnT", TnT);
})(jQuery, window);